// @flow

import { useCallback } from 'react';
import { useAppValues } from './context';

export function useAppValue<T>(name: string): [string, (T) => void] {
  const [appValues, setAppValues] = useAppValues();
  const currentValue = appValues[name];
  const setValue = useCallback((newValue: T) => {
    setAppValues({
      ...appValues,
      [name]: newValue,
    });
  });
  return [currentValue, setValue];
}
